import React from "react";
import { useParams } from "react-router";
import UploadImageContainer from "../../containers/gallery/uploadImage";

const UploadImagePage = () => {
  const { id } = useParams();
  return id ? <UploadImageContainer imageId={id} /> : <UploadImageContainer />;
};

export default UploadImagePage;
